import gql from 'graphql-tag';

const GET_FACULTIES = gql`
  query ListSchoolFaculties($first: Int!, $page: Int) {
    listSchoolFaculties(first: $first, page: $page) {
      paginatorInfo {
        currentPage
        lastPage
        total
        perPage
      }
      data {
        id
        faculty_name
        school_id
        type
        is_active
        createdAt
        updatedAt
        departments {
          id
          department_name
        }
      }
    }
  }
`;

const GET_DEPARTMENTS = gql`
  query ListSchoolDepartments($first: Int! = 100, $page: Int) {
   listSchoolDepartments(first: $first, page: $page) {
      paginatorInfo {
        currentPage
        lastPage
        total
        perPage
      }
      data {
        id
        department_name
        faculty_id
        type
        is_active
        createdAt
        updatedAt
      }
    }
  }
`;

const GET_PROGRAMMES = gql`
  query ListSchoolProgrammes($filter: programmeFilterInput, $first: Int! = 10, $page: Int) {
    listSchoolProgrammes(filter: $filter, first: $first, page: $page) {
      paginatorInfo {
        currentPage
        lastPage
        total
        perPage
      }
      data {
        id
        program_name
        prog_code
        degree
        type
        duration
        min_units
        calculation_method
        delivery_mode
             min_units_per_registration
             max_units_per_registration
        module_result_mode
        progression_type
        outstanding_mode
        compulsory_mode
        enforce_prerequisites
        graduation_criteria
        department_id
        is_active
        default_transcript_template_id
        default_transcript_template {
          id
          name
          style_code
        }
        default_result_template_id
        default_result_template {
          id
          name
        }
        createdAt
        updatedAt
      }
    }
  }
`;

const GET_COURSES = gql`
  query ListSchoolCourses(
    $first: Int!
    $page: Int
    $filter: CourseFilterInput
  ) {
    listSchoolCourses(
      first: $first
      page: $page
      filter: $filter
    ) {
      paginatorInfo {
        currentPage
        lastPage
        total
        perPage
      }
      data {
        id
        course_title
        course_code
        unit
        is_active
        course_instance_id
        course_instance_year
        createdAt
        updatedAt
      }
    }
  }
`;

const GET_COURSE_BY_ID = gql`
  query GetCourseById($id: ID!) {
    getCourse(id: $id) {
      id
      course_title
      course_code
      unit
      is_active
      course_instance_id
      course_instance_year
      school_id
      createdAt
      updatedAt
    }
  }
`;

const GET_COURSE_LECTURERS = gql`
  query GetCourseLecturersInSemester($course_id: Int!, $academic_calendar_id: Int) {
    getCourseLecturersInSemester(course_id: $course_id, academic_calendar_id: $academic_calendar_id) {
      id
      course_id
      academic_calendar_id
      school_id
      is_approved
      approved_by_id
      approved_at
      denied_by_id
      denied_at
      created_at
      updated_at
      user {
        id
        name
        email
      }
      course {
        id
        course_code
        course_title
        unit
      }
    }
  }
`;

const GET_CURRICULUMS = gql`
  query ListSchoolCurriculums($filter: curriculumFilterInput, $first: Int! = 10, $page: Int) {
    listSchoolCurriculums(filter: $filter, first: $first, page: $page) {
      paginatorInfo {
        currentPage
        lastPage
        total
        perPage
      }
      data {
        id
        course_id
        programme_id
        status
        course_registration_level
        semester
        moduleOfferings { id name session_id }
        programme_module_id
        course {
          id
          course_code
          course_title
          course_code
          course_instance_id
          course_instance_year
          unit
        }
        programme {
          id
          prog_code
          program_name
          degree
          type
          duration
          min_units
          department_id
          delivery_mode
             min_units_per_registration
             max_units_per_registration
          progression_type
        }
        programmeModule {
          id
          name
          sequence
        }
      }
    }
  }
`;

const GET_USERS_WITH_COURSE_LECTURERS = gql`
  query UsersWithCourseLecturers($filter: lecturerCourseFilterInput, $first: Int! = 10, $page: Int) {
    usersWithCourseLecturers(filter: $filter, first: $first, page: $page) {
      paginatorInfo {
        currentPage
        lastPage
        total
        perPage
      }
      data {
        id
        name
        email
      }
    }
  }
`;

const GET_LECTURER_COURSES_IN_SEMESTER = gql`
  query GetLecturerCoursesInSemester($input: lecturerGetCoursesInSemesterInput!) {
    getLecturerCoursesInSemesterByAdmin(input: $input) {
      id
     
      course_id
      academic_calendar_id
      school_id
      is_approved
      approved_by_id
      approved_at
      denied_by_id
      denied_at
      created_at
      updated_at
      user {
        id
        name
        email
      }
      course {
        id
        course_code
        course_title
        course_instance_id
        course_instance_year
        unit
      }
    }
  }
`;

const GET_LECTURER_COURSES = gql`
  query GetLecturerCourses($input: lecturerGetCoursesInSemesterInput!) {
    getLecturerCoursesInSemesterByAdmin(input: $input) {
      id
      course_id
      academic_calendar_id
      school_id
      is_approved
      approved_by_id
      approved_at
      denied_by_id
      denied_at
      created_at
      updated_at
      user {
        id
        name
      }
      course {
        id
        course_code
        course_title
        course_instance_id
        course_instance_year
        unit
      }
    }
  }
`;

const SCHOOL_COURSE_REGISTRATION = gql`
  query SchoolCourseRegistration(
    $academic_calendar_id: Int
    $filter: courseRegistrationFilterInput
    $first: Int!
    $page: Int
  ) {
    schoolCourseRegistration(
      academic_calendar_id: $academic_calendar_id
      filter: $filter
      first: $first
      page: $page
    ) {
      paginatorInfo {
        currentPage
        lastPage
        perPage
        total
        hasMorePages
      }
      data {
        id
        student_id
        academic_session
        semester
        registration_level
        programme_id
        academic_calendar_id
        authorization_status
        approval_status
        senate_approval_status
        rejection_reason
        createdAt
        updatedAt


        student {
          id
          first_name
          surname
          matric_no
        }


        programme {
          id
          program_name
        } 
       coursesRegistered {
          programme_module_id
          module_name
          module_sequence
          id
          course_id
          course {
            id
            course_title
            course_instance_id
            course_instance_year
            course_code
            unit
          }
            scores {
            id
            score
            comments
            approval_status
            }
        }
      }
    }
  }
`;
        
const GET_PENDING_COURSE_REGISTRATIONS_FOR_APPROVAL = gql`
  query PendingCourseRegistrationsForApproval($filter: CourseRegistrationApprovalFilterInput) {
    pendingCourseRegistrationsForApproval(filter: $filter) {
      paginatorInfo {
        currentPage
        lastPage
        total
        perPage
      }
      data {
        student {
          id
          surname
          first_name
          matric_no
        }
        academic_calendar {
          id
          session { id name }
          termStructure { id name }
        }
        session
        semester
        level
        programme
        registrations {
          id
          authorization_status
          approval_status
          coursesRegistered {
          programme_module_id
          module_name
          module_sequence
            id
            course_id
            course_status
            course {
              id
              course_code
              course_title
              unit
            }
          }
        }
        total_units
        course_count
        level_adviser {
          id
          name
        }
        level_adviser_approved_at
      }
    }
  }
`;

const GET_COURSE_REGISTRATIONS_FOR_STUDENT = gql`
  query GetCourseRegistrationsForStudent($student_id: Int!) {
    getCourseRegistrationsForStudent(student_id: $student_id) {
      academicCalendar { id session_id }
      id
      student_id
      academic_session
      semester
      registration_level
      programme_id
      academic_calendar_id
      authorization_status
      approval_status
      rejection_reason
      school_id
      createdAt
      updatedAt
      student {
        id
        first_name
        surname
        other_name
        matric_no
        email
        phone
        photo
        gender
        currentClassroomSection {
          id
          name
          classroom {
            id
            name
          }
        }
        studentAcademicCalendar {
          id
          min_units_per_registration
          max_units_per_registration
        }
      }
      programme {
        id
        program_name
        degree
        delivery_mode
      }
        coursesRegistered {
          programme_module_id
          module_name
          module_sequence
          id
          course_id
          course_status
          accepted_for_programme_id
          course {
            id
            course_title
            course_instance_id
            course_instance_year
            course_code
            unit
          }
          scores {
            id
            score
            comments
            school_assessment_type_id
            schoolAssessmentType {
              id
              name
            }
            approval_status
          }
        }
    }
  }
`;
  
const GET_PENDING_COURSE_REGISTRATIONS_FOR_ENDORSEMENT = gql`
  query PendingCourseRegistrationsForEndorsement($filter: CourseRegistrationApprovalFilterInput) {
    pendingCourseRegistrationsForEndorsement(filter: $filter) {
      paginatorInfo {
        currentPage
        lastPage
        total
        perPage
      }
      data {
        student {
          id
          surname
          first_name
          matric_no
        }
        academic_calendar {
          id
          session { id name }
          termStructure { id name }
        }
        session
        semester
        level
        programme
        registrations {
          id
          authorization_status
          approval_status
          coursesRegistered {
          programme_module_id
          module_name
          module_sequence
            id
            course_id
            course_status
            course {
              id
              course_code
              course_title
              unit
            }
          }
        }
        total_units
        course_count
        level_adviser {
          id
          name
        }
        level_adviser_approved_at
      }
    }
  }
`;

const GET_REGISTRATIONS_FOR_COURSE = gql`
  query GetRegistrationsForCourseInCurrentCalendar($course_id: Int!, $academic_calendar_id: Int) {
    getRegistrationsForCourseInCurrentCalendar(course_id: $course_id, academic_calendar_id: $academic_calendar_id) {
      id
      student_id
      programme_id
      academic_calendar_id
      registration_level
      semester
      academic_session
      approval_status
      authorization_status
      student {
        id
        first_name
        surname
        other_name
        matric_no
        email
        phone
        photo
      }
      programme {
        id
        program_name
        prog_code
      }
      coursesRegistered {
          programme_module_id
          module_name
          module_sequence
        id
        course_id
        course_status
        scores {
          id
          school_assessment_type_id
          schoolAssessmentType {
            id
            name
          }
          score
          approval_status
        }
      }
    }
  }
`;

export {
  GET_FACULTIES,
  GET_DEPARTMENTS,
  GET_PROGRAMMES,
  GET_COURSES,
  GET_COURSE_BY_ID,
  GET_CURRICULUMS,
  GET_CAMPUSES,
  GET_STUDENT_RESULT,
  SCHOOL_COURSE_REGISTRATION,
  GET_COURSE_REGISTRATIONS_FOR_STUDENT,
  GET_USERS_WITH_COURSE_LECTURERS,
  GET_LECTURER_COURSES_IN_SEMESTER,
  GET_LECTURER_COURSES,
  GET_COURSE_LECTURERS,
  GET_PENDING_COURSE_REGISTRATIONS_FOR_APPROVAL,
  GET_PENDING_COURSE_REGISTRATIONS_FOR_ENDORSEMENT,
  GET_REGISTRATIONS_FOR_COURSE,
  GET_TERTIARY_RESULT_SUMMARY_SHEET,
};

const GET_CAMPUSES = gql`
  query ListSchoolCampuses($filter: campusFilterInput) {
    listSchoolCampuses(filter: $filter, first: 100) {
      data {
        id
        name
        student_count
      }
    }
  }
`;

const GET_STUDENT_RESULT = gql`
  query GetStudentResultBasicTertiary($studentId: ID!, $calendarId: ID!) {
    studentResult(student_id: $studentId, academic_calendar_id: $calendarId) {
        status           # PUBLISHED / NOT_PUBLISHED


        # Dynamic Headers Definition
        headers {
            label        # Display Name (e.g., "CA", "Exam")
            key          # Data Key (e.g., "ca", "exam", "total")
            type         # ASSESSMENT, CALCULATION, GRADE, UNIT
            is_visible   # Boolean
        }
        # Dynamic Data Rows
        data             # JSON Array of Objects


        # Context Info
        student {
            id
            surname
            first_name
            matric_no
        }
        academic_calendar {
            id
            session {
                id
                name
            }
            termStructure {
                id
                name
            }
        }
        template {
            id
            name
        }
    }
}
`;

const GET_TERTIARY_RESULT_SUMMARY_SHEET = gql`
  query GetTertiaryResultSummarySheet($input: ResultSummarySheetInput!) {
    getTertiaryResultSummarySheet(input: $input) {
      header {
        session
        semester
        program_name
        department_name
        faculty_name
        level
      }
      summary {
        excellent
        very_good
        good
        fair
        pass
        poor
        fail
        first_class
        second_class_upper
        second_class_lower
        third_class
        other
        average
      }
      students {
        sn
        student_id
        matric_number
        names
        prev_tcp
        prev_tnup
        prev_tnur
        prev_cgpa
        curr_tcp
        curr_tnup
        curr_tnur
        curr_gpa
        cum_tcp
        cum_tnup
        cum_tnur
        cum_cgpa
        status
        failed_compulsory_courses_list
        degree_class
      }
    }
  }
`;

export const GET_LECTURER_STUDENT_ALLOCATIONS = gql`
  query GetLecturerStudentAllocations($course_id: ID!, $academic_calendar_id: ID) {
    getLecturerStudentAllocations(course_id: $course_id, academic_calendar_id: $academic_calendar_id) {
      course_lecturer_id
      lecturer_name
      school_staff_id
      allocated_count
      students {
        id
        course_id
        studentCourseRegistration {
          id
          student_id
          registration_level
          programme {
            id
            program_name
            prog_code
          }
          student {
            id
            first_name
            surname
            matric_no
          }
        }
      }
    }
  }
`;

export const GET_UNALLOCATED_STUDENTS = gql`
  query GetUnallocatedStudents($course_id: ID!, $academic_calendar_id: ID) {
    getUnallocatedStudents(course_id: $course_id, academic_calendar_id: $academic_calendar_id) {
      id
      course_id
      studentCourseRegistration {
        id
        student_id
        registration_level
        programme {
          id
          program_name
          prog_code
        }
        student {
          id
          first_name
          surname
          matric_no
        }
      }
    }
  }
`;

export const GET_PENDING_APPROVAL_NOTIFICATION_SUBSCRIPTION = gql`
  query PendingApprovalNotificationPreference {
    pendingApprovalNotificationSubscription {
      topic
      subscribed
      scopes {
        id
        schoolWide
        departmentId
        departmentName
        programmeId
        programmeName
      }
    }
  }
`;

export const LIST_PROGRAMME_MODULES = gql`
  query ListProgrammeModules($programme_id: ID!, $session_id: ID, $academic_calendar_id: ID) {
    listProgrammeModules(
      programme_id: $programme_id
      session_id: $session_id
      academic_calendar_id: $academic_calendar_id
    ) {
      id
      programme_id
      session_id
      academic_calendar_id
      name
      registration_fee
      retake_fee
      registration_fee_item_template_id
      retake_fee_item_template_id
      sequence
      min_units_per_registration
      max_units_per_registration
      started_at
      ended_at
      is_active
      is_open
      session {
        id
        name
      }
      academicCalendar {
        id
        term_structure_id
      }
    }
  }
`;

export const SESSIONS_WITH_CALENDARS = gql`
  query SessionsWithCalendars {
    schoolSessions {
      id
      name
      academicCalendars {
        id
        termStructure {
          id
          name
        }
      }
    }
  }
`;

export const GET_COURSES_WITH_PREREQUISITES = gql`
  query ListCoursesWithPrerequisites(
    $first: Int!
    $page: Int
    $filter: CourseFilterInput
  ) {
    listSchoolCourses(
      first: $first
      page: $page
      filter: $filter
    ) {
      paginatorInfo {
        currentPage
        lastPage
        total
        perPage
      }
      data {
        id
        course_title
        course_code
        unit
        is_active
        prerequisites {
          id
          prerequisite_course_id
          prerequisiteCourse {
            id
            course_code
            course_title
            unit
          }
        }
      }
    }
  }
`;
